"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Hook to Add/remove listeners to a container to block esc propagation
 *  This is based on "keyup" as that works better with our third-party components (DatePicker, TreeSelect and RichSelect)
 *  these close on "keydown" and then propagation of "keyup" is managed to avoid closing the modal if they are composed in one.
 */
var React = require("react");
/**
 * @param containerRef
 * @param blockPropagation - whether to default to blocking propagation on mount, defaults to false but DatePicker v1.x needs it to default to true
 */
var useEscPropagationHandler = function (containerRef, blockPropagation) {
    if (blockPropagation === void 0) { blockPropagation = false; }
    var _a = __read(React.useState(blockPropagation), 2), stopEsc = _a[0], setStopEsc = _a[1];
    // state is managed by hook consumers
    var allowEscPropagation = function () { return setStopEsc(false); };
    var blockEscPropagation = function () { return setStopEsc(true); };
    React.useEffect(function () {
        var container = containerRef && containerRef.current;
        if (!container)
            return;
        var handleKeyUp = function (event) {
            if (["Escape", "Esc"].includes(event.key) && stopEsc) {
                event.stopPropagation();
                // make sure and only do this once
                allowEscPropagation();
            }
        };
        container.addEventListener("keyup", handleKeyUp);
        return function () {
            container.removeEventListener("keyup", handleKeyUp);
        };
    }, [containerRef.current, stopEsc]);
    return { allowEscPropagation: allowEscPropagation, blockEscPropagation: blockEscPropagation };
};
exports.default = useEscPropagationHandler;
//# sourceMappingURL=useEscPropagationHandler.js.map